import { CheckCircle, Package, MapPin, User, ArrowDownToLine, ArrowUpFromLine } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useNavigate } from "react-router-dom";

function formatDate(isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  const isYesterday = date.toDateString() === yesterday.toDateString();
  
  const time = date.toLocaleTimeString("sv-SE", { hour: "2-digit", minute: "2-digit" });
  
  if (isToday) return `Idag ${time}`;
  if (isYesterday) return `Igår ${time}`;
  return date.toLocaleDateString("sv-SE", { day: "numeric", month: "short" }) + ` ${time}`;
}

export function RecentScansList({ scans }) {
  const navigate = useNavigate();
  if (!scans || scans.length === 0) return null;

  return (
    <Card data-testid="recent-scans">
      <CardContent className="p-4">
        <h3 className="text-sm font-medium text-muted-foreground mb-3 flex items-center gap-2">
          <CheckCircle className="h-4 w-4" />
          Senaste skanningar
        </h3>
        <div className="space-y-2">
          {scans.map((scan, index) => {
            const isOut = scan.action === "scanned_out" || scan.action_type === "OUT";
            const IconComponent = isOut ? ArrowUpFromLine : ArrowDownToLine;
            
            return (
              <div
                key={index}
                className="flex items-center justify-between py-2 border-b border-border last:border-0 cursor-pointer hover:bg-accent/50 rounded -mx-1 px-1 transition-colors"
                onClick={() => navigate(`/inventory/${scan.item?.ean || scan.ean}`)}
              >
                <div className="flex items-center gap-3">
                  <div className={isOut 
                    ? "w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center"
                    : "w-8 h-8 rounded-full bg-green-500/10 flex items-center justify-center"
                  }>
                    <IconComponent className={isOut ? "h-4 w-4 text-red-500" : "h-4 w-4 text-green-500"} />
                  </div>
                  <div>
                    <p className="font-medium text-sm">
                      {scan.item?.artikelnummer || scan.item?.ean}
                    </p>
                    <div className="flex items-center gap-2 text-xs text-muted-foreground">
                      <MapPin className="h-3 w-3" />
                      {scan.item?.lagerplats}
                      <span>•</span>
                      <span className={isOut ? "text-red-500" : "text-green-500"}>
                        {isOut ? "-" : "+"}{scan.item?.antal} st
                      </span>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xs text-muted-foreground">
                    {formatDate(scan.timestamp)}
                  </p>
                  {scan.username && (
                    <div className="flex items-center gap-1 text-xs text-muted-foreground">
                      <User className="h-3 w-3" />
                      {scan.username}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
